import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space } = theme

export const ImageWrapper = styled.div`
  position: relative;
`

export const Image = styled.div`
  position: relative;
  top: ${space['spacing-xs']};
  right: 0;
  width: 100%;

  @media (${media.tablet}) {
    position: absolute;
    z-index: 1;
    top: 0;
  }
`